import Card from "@/components/shared-ui/Card";
import styled from "styled-components";

export const TransferProviderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`;

export const TransferProviderItem = styled(Card)`
  padding: 0;
`;

export const ItemInnerContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  gap: 1rem;

  ${(props) => props.theme.media.large} {
    grid-template-columns: 11rem minmax(0, 1fr);
  }
`;

export const ItemDetails = styled.div`
  align-items: start;
  background: ${(props) => props.theme.gradients.light2};
  border-radius: 0.5rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
  padding: 1rem;

  ${(props) => props.theme.media.medium} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${(props) => props.theme.media.large} {
    align-items: center;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const ItemField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  strong {
    font-weight: 500;
  }
  span {
    font-size: 0.875rem;
  }
`;

export const Status = styled.span<{
  $colour: string;
  $backgroundColour: string;
}>`
  align-items: center;
  align-self: flex-start;
  background: ${(props) => props.$backgroundColour};
  border-radius: 1rem;
  display: inline-flex;
  gap: 0.5rem;
  padding: 0.125rem 0.75rem 0.125rem 0.375rem;
  font-weight: 300;
  &::before {
    background: ${(props) => props.$colour};
    border-radius: 50%;
    content: "";
    flex: 0 0 1rem;
    height: 1rem;
  }
`;

export const StatusDot = styled.strong<{
  $colour: string;
}>`
  align-items: center;
  align-self: flex-start;
  display: inline-flex;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.125rem 0;

  &::before {
    background: ${(props) => props.$colour};
    border: 3px solid ${(props) => props.theme.colors.lightest};
    border-radius: 50%;
    content: "";
    flex: 0 0 20px;
    height: 20px;
    width: 20px;
  }
`;

export const Logo = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  justify-self: center;
  padding: 1rem;
  height: 85px;
  width: 175px;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

`;

export const Key = styled(Card)`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const KeyHeading = styled.h3`
  color: ${(props) => props.theme.colors.accent1};
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
`;

export const KeyField = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
  padding: 1rem 0;

  &:last-child {
    border-bottom: 0;
  }

  ${(props) => props.theme.media.medium} {
    gap: 2rem;
    grid-template-columns: 11rem minmax(0, 1fr);
  }
`;

export const KeyFieldHeading = styled.strong`
  line-height: 1.25;
`;

export const KeyStatuses = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: minmax(0, 1fr);

  ${(props) => props.theme.media.medium} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${(props) => props.theme.media.large} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const KeyStatus = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > span {
    font-size: 0.875rem;
    line-height: 1.35;
  }
`;
